/**
 * Court layer: the per-court details wizards add to their statewide base.
 *
 * A wizard's questions, steps and deadlines come from the CCP, the CRC and Judicial Council
 * forms, so it works in every court. Where a court has local data in data/, its entry here
 * adds or replaces the details that vary by court. A wizard reads them with courtDetail()
 * (lib/courtlayer.js), which returns a "verify" item naming the court when there is no entry.
 * Wizard modules hold no court's details themselves.
 *
 * Shape of an entry (every part optional):
 *
 *   {
 *     id,                    // court id from src/content/courts.json
 *     holidays: {            // read by calendarFor() in lib/courtdays.js
 *       observed: [iso],     // the court's published holiday schedule
 *       closures: [{ date, name }],  // other days it is closed
 *       through: iso,        // last date the schedule covers
 *       cite,
 *     },
 *     details: {             // each leaf is a Detail
 *       fees:        { firstPaper },  // value: { unlimited, limitedOver10k, limitedUpTo10k, udLimitedOver10k, udLimitedUpTo10k }
 *       departments: { caseManagement, lawAndMotion, discovery, exParte, unlawfulDetainer, presidingJudge, ... },
 *       rules:       { courtesyCopies, cmcNotice, cmStatement, adrPackage, adrStipulation, tentativeRulings, ... },  // local rules and requirements
 *       forms:       { coverSheetAddendum, defaultDeficiency, ... },  // local forms not tied to a rule above
 *       efiling:     { represented, selfRepresented, conventionalInitiating, ... },
 *       hearingReservation: { lawAndMotion, discovery, ... },
 *     },
 *   }
 *
 * A Detail is { text, cite, forms?, value? }:
 *   text   what the checklist says, in full sentences
 *   cite   where it comes from (local rule, court web page or form), as the checklist shows it
 *   forms  forms.json ids the step links to
 *   value  a machine-readable value a wizard can branch on (a department number, true/false,
 *          or { classes: [...] } for a detail that applies only to some case classes)
 *
 * Keys are shared across courts, so a wizard asks for "departments.lawAndMotion" and gets
 * whichever court's answer applies. Add a key when a second wizard or court needs it.
 */
import sf from "./sf-superior.js";
import alameda from "./alameda-superior.js";
import riverside from "./riverside-superior.js";
import sanBernardino from "./san-bernardino-superior.js";

export const COURT_DETAILS = {
  [sf.id]: sf,
  [alameda.id]: alameda,
  [riverside.id]: riverside,
  [sanBernardino.id]: sanBernardino,
};
